/**
 * Crater Shape Configs — organic terrain destruction shape parameters.
 *
 * Shared by weapons.ts (weapon crater shapes), tanks/ (shot tier crater shapes),
 * and game/death.ts (death crater shapes). Lives in terrain/ because it's a
 * terrain-layer concept with no upstream dependencies.
 */

import type { CraterShapeConfig } from '../types';

export const DEFAULT_CRATER: CraterShapeConfig = {
  primaryFreq: 3, primaryAmp: 0.15,
  detailFreq: 8, detailAmp: 0.07,
  fineFreq: 20, fineAmp: 0.03,
  verticalBias: 0,
};

export const AXE_SPLIT_CRATER: CraterShapeConfig = {
  primaryFreq: 2, primaryAmp: 0.06,
  detailFreq: 8, detailAmp: 0.03,
  fineFreq: 18, fineAmp: 0.02,
  verticalBias: 0.88,
};

export const HUGE_CRATER: CraterShapeConfig = {
  primaryFreq: 2, primaryAmp: 0.20,
  detailFreq: 6, detailAmp: 0.10,
  fineFreq: 15, fineAmp: 0.05,
  verticalBias: 0,
};

export const SMALL_CRATER: CraterShapeConfig = {
  primaryFreq: 5, primaryAmp: 0.12,
  detailFreq: 12, detailAmp: 0.05,
  fineFreq: 25, fineAmp: 0.02,
  verticalBias: 0,
};

export const VOID_DEATH_CRATER_SHAPE: CraterShapeConfig = {
  primaryFreq: 4, primaryAmp: 0.18,
  detailFreq: 9, detailAmp: 0.08,
  fineFreq: 22, fineAmp: 0.03,
  verticalBias: 0.2,
};
